<template>
  <v-container class="pa-0 ma-0">
    <v-card class="pa-4 ma-0">
      <!-- Global info-->
      <v-container class="chart-header d-flex justify-space-between pa-0 ma-0">
        <v-card-text class="pa-0 ma-0 text-body-2"
          >{{ $t("salesPurchaseTrend") }}
        </v-card-text>
        <v-chip size="small" outlined>{{ $t("lastSixMonths") }}</v-chip>
      </v-container>
      <!-- area chart-->
      <apexchart
        v-if="hasData"
        type="area"
        height="337"
        width="100%"
        :options="chartOptions"
        :series="chartSeries"
      />
      <v-container
        v-else
        class="pa-0 ma-0 d-flex flex-column align-center justify-center"
        style="height: 337px"
      >
        <img
          :src="require('@/assets/dashboard/no-data(3).png')"
          max-width="100"
          height="100"
          contain
          class="mb-3"
        />
        <v-card-text class="text-body-2 grey--text text-center">
          {{ $t("nothing-for-render") }}
        </v-card-text>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      chartRawData: {},
      loading: false,
    };
  },
  computed: {
    hasData() {
      return this.chartSeries[0].data.some((val) => val > 0);
    },
    lastSixMonthsData() {
      return Object.values(this.chartRawData || {}).slice(-6);
    },

    chartSeries() {
      return [
        {
          name: this.$t("sell"),
          data: this.lastSixMonthsData.map(
            (item) => item.monthlyInvoices?.sell?.amount ?? 0
          ),
        },
        {
          name: this.$t("purchase"),
          data: this.lastSixMonthsData.map(
            (item) => item.monthlyInvoices?.purchase?.amount ?? 0
          ),
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          type: "area",
          toolbar: { show: false },
          fontFamily: "IRANSans",
        },

        stroke: {
          curve: "smooth",
          width: 2,
        },

        colors: ["#3B82F6", "#10B981"],

        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            opacityFrom: 0.45,
            opacityTo: 0.05,
          },
        },
        xaxis: {
          categories: this.lastSixMonthsData.map((item) => item.label),
          axisBorder: { show: false },
          axisTicks: { show: false },
        },

        yaxis: {
          labels: {
            show: true,
            style: {
              fontSize: "10px",
            },
            offsetX: this.$vuetify.rtl ? -80 : 0,
            formatter: (value) => {
              return `${this.$numberFormat(value)} ${this.$store.state.currency.name}`;
            },
          },
        },

        grid: {
          strokeDashArray: 4,
        },

        legend: {
          position: "bottom",
          horizontalAlign: "center",
        },

        tooltip: {
          y: {
            formatter: (value) =>
              `${value.toLocaleString()} ${this.$store.state.currency.name}`,
          },
        },

        dataLabels: {
          enabled: false,
        },
      };
    },
  },
  mounted() {
    this.getInvoiceByMonth();
  },
  methods: {
    getInvoiceByMonth() {
      this.loading = true;

      this.$axios
        .get(this.$endpoint + "dashboard/charts/invoice-by-month", {
          params: { dateType: "year" },
        })
        .then((response) => {
          this.chartRawData = response.data?.data || {};
        })
        .catch((error) => {
          console.error("Invoice chart error:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
::v-deep .apexcharts-legend.position-bottom .apexcharts-legend-series,
::v-deep .apexcharts-legend.position-top .apexcharts-legend-series {
  gap: 0.5rem;
  padding-top: 10px;
}
.chart-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}
</style>
